<template>
  <page :title="$tc('magazine')+' / '+$tc('issue')">
    <div slot="page-header-right">
      <router-link to="issues/create">
        <button class="button is-primary">
          <b-icon icon="plus"></b-icon>
          <span>
            <slot>{{$tc('add.issue')}}</slot>
          </span>
        </button>
      </router-link>
    </div>

    <div class="box">
      <b-field>
        <b-input
          @blur="searchChanged()"
          :placeholder="$tc('dater.range')"
          type="search"
          v-model="query"
          icon="magnify"
          icon-clickable
          @input="(search) => issues.filter({ search }).load()"
          expanded
        ></b-input>
      </b-field>

      <hr/>

      <div class="card-content is-paddingless">
        <b-table
          :data="issues.data"
          :loading="issues.loading"
          paginated
          backend-pagination
          pagination-position="bottom"
          :current-page="issues.current_page"
          :per-page="issues.per_page"
          :total="issues.total"
          @page-change="(page) => issues.changePage(page)"
          backend-sorting
          @sort="(field, direction) => issues.sort(field, direction)"
          :default-sort="['id', 'desc']"
          class="is-middle"
        >
          <template slot-scope="props">
            <b-table-column field="id" label="Id" sortable width="80">{{
                props.row.id
              }}
            </b-table-column>

            <b-table-column field="cover" width="60">
              <img :src="props.row.cover_image_url" width="50"/>
            </b-table-column>

            <b-table-column field="title" :label="$tc('support_ticket.title')" sortable>
              <router-link
                :to="`/magazine/magazines/${props.row.magazine_id}/edit`"
                class="has-text-grey mr-2"
              >{{ props.row.magazine.name }} /
              </router-link
              >

              <router-link
                :to="`/magazine/magazine/issues/${props.row.id}/edit`"
                class="has-text-dark"
                size="is-large"
              >{{ props.row.title }}
              </router-link
              >
            </b-table-column>

            <b-table-column
              field="published_at"
              :label="$tc('support_ticket.status._name')"
              sortable
              centered
            >
              <b-tooltip
                v-if="props.row.published_at != null"
                :label="props.row.published_at"
              >
                <span class="tag is-success">{{ props.row.state }}</span>
              </b-tooltip>

              <span v-else class="tag">{{ props.row.state }}</span>
            </b-table-column>

            <b-table-column
              :label="$tc('pages')"
              centered
              class="has-text-grey"
            ></b-table-column>

            <b-table-column
              field="release_date"
              width="180"
              :label="$tc('dater.latest')"
              centered
              sortable
              class="has-text-grey"
            >
              <b-tooltip :label="props.row.release_date">{{
                  props.row.release_date | date
                }}
              </b-tooltip>
            </b-table-column>

            <b-table-column
              field="created_at"
              width="180"
              :label="$tc('dater.created')"
              centered
              sortable
              class="has-text-grey"
            >{{ props.row.created_at | date }}
            </b-table-column
            >

            <b-table-column custom-key="actions" width="300">
              <div class="is-pulled-right">
                <links-dropdown
                  class="mr-2"
                  :links="[
                    {
                      label: 'Deep Link to read',
                      url: `${dl}://q?type=read_issue&id=${props.row.id}`,
                    },
                    {
                      label: 'Deep Link to detail',
                      url: `${dl}://q?type=issue&id=${props.row.id}`,
                    },
                  ]"
                ></links-dropdown>

                <router-link
                  class="button mr-2"
                  :to="`/magazine/magazine/issues/${props.row.id}/stats/opens`"
                ><i class="mdi mdi-chart-bar mdi-24px"></i></router-link>

                <router-link
                  class="button mr-2"
                  :to="`/magazine/magazine/issues/${props.row.id}`"
                >{{ $tc('detail') }}
                </router-link
                >

                <router-link
                  class="button"
                  :to="`/magazine/magazine/issues/${props.row.id}/edit`"
                >{{ $tc('edit') }}
                </router-link
                >
              </div>
            </b-table-column>
          </template>

          <template slot="empty">
            <section class="section">
              <div class="content has-text-grey has-text-centered">
                <p>
                  <b-icon icon="emoticon-sad" size="is-large"></b-icon>
                </p>
                <p>{{$tc('Nothinghere')}}</p>
              </div>
            </section>
          </template>
        </b-table>
      </div>
    </div>
  </page>
</template>

<script>
export default {
  data() {
    return {
      query: localStorage.getItem('issue-search') || '',
      issues: new window.PaginatedRemoteCollection(
        "/admin/api/magazine/issues?include=magazine"
      ),
      dl: this.$store.state.config.app.dl
    };
  },

  created() {
    this.issues.filter({ search: this.query }).load();
  },

  methods: {
    searchChanged() {
      localStorage.setItem('issue-search', this.query);
    }
  }
};
</script>
